<template lang="pug">
.page
  section
    .max-width
      .row.vertical.center
        .col
          .logo-wrapper
            img.logo(src="../../assets/images/logo-white-text.svg")
        .col
          .form-wrapper
            form(@keyup.enter.prevent="submit", @submit.prevent="submit")
              h1.primary-text Login to Feature Watch
              AlertBox(v-if="error", type="danger", :text="error")
              .form-field(
                :class="{ error: $v.form.email.$error, 'error-required': !$v.form.email.required }"
              )
                label
                  input(
                    placeholder="Email Address",
                    v-model="$v.form.email.$model",
                    type="email"
                  )

              .form-field(
                :class="{ error: $v.form.password.$error, 'error-required': !$v.form.password.required }"
              )
                label
                  input(
                    placeholder="Password",
                    v-model="$v.form.password.$model",
                    type="password"
                  )

              .form-field
                .row.apart.center
                  .col
                    button.button.primary-button(type="submit") Login
                  .col
                    router-link.minor-link(:to="{ name: 'ForgotPassword' }") Forgot Password?

            //- div.social-login
            //-   span Or login with:
            //- .row.gap-1
            //-   .col
            //-     button.button.button-social.button-google(
            //-       type="button",
            //-       @click="doGoogle"
            //-     )
            //-       //-font-awesome-icon.icon(:icon="['fab', 'google']")
            //-       img(src="../../assets/images/google_icon@2x.png")
            //-       span Google
        .col
          p.footer
            | Don't have an account?&nbsp;
            router-link.link(:to="{ name: 'register' }") Sign up!
</template>

<script>

import { required } from 'vuelidate/lib/validators'

export default {
  name: 'login',
  components: {
  },
  data () {
    return {
      error: null,
      form: {
        email: '',
        password: ''
      }
    }
  },
  validations: {
    form: {
      email: {
        required
      },
      password: {
        required
      }
    }
  },
  methods: {
    submit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        console.log('invalid')
      } else {
        this.$store.dispatch('user/login', this.form)
          .then(({company, showOnboarding}) => {
            //console.log(company)
            let route = `https://${company.subdomain}.feature.watch/${company.isMember ? 'admin' : ''}${showOnboarding ? '/welcome' : ''}`
            if (process.env.NODE_ENV === 'development') {
              route = `http://${company.subdomain}.feature.watch:3000/${company.isMember ? 'admin' : ''}${showOnboarding ? '/welcome' : ''}`
            }
            //console.log(route)
            window.location.href = route
            //this.$router.push(route).catch(err => {})
          }, error => {
            //console.log('[error]', error.error)
            this.error = error.error
          })
      }
    },
    // doGoogle(){
    //   const height = 600
    //   const width = 500
    //   const left = (window.screen.width / 2) - ((width / 2) + 10)
    //   const top = (window.screen.height / 2) - ((height / 2) + 50)

    //   const params = 'status=no,height=' + height + ',width=' + width + ',resizable=yes,left=' +
    //   left + ',top=' + top + ',screenX=' + left + ',screenY=' +
    //   top + ',toolbar=no,menubar=no,scrollbars=no,location=no,directories=no'

    //   const popup = window.open(
    //     '/oauth/loading/google',
    //     'GooglePopup',
    //     params
    //   )
    // }
  },
  created () {
    this.oAuthListener = (msg) => {
      // console.log('oAuthListener', msg)
      const authSuccess = (msg.data.data === 'auth_success')
      const authError = (msg.data.data === 'auth_failure')

      if (authSuccess) {
        this.$store.commit('user/SET_TOKEN', msg.data.token)
        let route = `https://${msg.data.subdomain}.feature.watch/admin` // all oAuth is currently only for company users
        window.location.href = route
        //this.$router.push({ name: 'Dashboard' }).catch(err => {})
      }

      if (authError) {
        this.error = msg.data.errorMsg
      }
    }

    window.addEventListener('message', this.oAuthListener)

    this.$once("hook:destroyed", () => {
      console.log('hook:destroy')
      window.removeEventListener('message', this.oAuthListener)
    })
  }
}
</script>

<style lang="stylus" scoped>
.page
  margin 0 auto
  +for_breakpoint(mobile)
    padding 40px 0

.logo-wrapper
  margin-bottom 60px
  text-align center
  img
    max-width 521px
    +for_breakpoint(mobile)
      max-width 100%

.social-login
  color $text-light
  font-size $text-smaller
  padding-top $spacing
  margin-bottom $spacing-2

.form-wrapper
  background-color #fff
  border-radius $border-radius
  //margin-left $spacing-3
  margin-bottom 60px
  padding $spacing-5 $spacing-3
  width 412px
  +for_breakpoint(mobile)
    width auto
  h1
    font-size 22px
    text-align center
    margin-bottom 40px
  form
    margin 0 auto
    //max-width 400px
p.footer
  color #fff
</style>
